import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    useMediaQuery,
  } from "@mui/material";
  import { MainBox } from "../../../theme/global.styles";
  import Ellipsis from "../../ellipsis/ellipsis.component";
  import { ReactComponent as ExpandMoreIcon } from "../../../icons/arrow-down-short.svg";
  import {
    CMArtistBio,
    CMAuctionAbout,
    CMTrackList,
    CMTracksPerformance,
  } from "./auction-about.styles";
  import { useEffect, useRef, useState } from "react";
  import ArtistMomentum from "../artist-momentum/artist-momentum.component";
  import AuctionMentions from "../auction-mentions/auction-mentions.component";
  import TrackList from "../../track-list/track-list.component";
  import TrackPerformance from "../track-performance/track-performance.component";
import styled from "styled-components";
import { useLocation } from "react-router-dom";

const StyledAccordionSummary = styled(AccordionSummary)`
font-size: inherit;

@media (min-width: 2000px) {
  font-size: 3vh;

  h3 {
    font-size: 3vh;
  }
  svg {
    width: 2vw;
    height: 3vh;
  }
}
`;

  const StyledAccordionDetails = styled(AccordionDetails)`
  font-size: inherit;

  @media (min-width: 2000px) {
    font-size: 3vh;

    h4 {
      font-size: 3vh;
    }
    p {
      font-size: 2vh;
    }
  }
`;
  
  const AuctionAbout = ({ auction, symbolType, page, ...props }) => {
    return (
      <CMAuctionAbout className="dotted-border">
        {symbolType === "Album" ? (
          <AlbumAbout auction={auction} page={page}/>
        ) : (
          <>
            {symbolType === "Single" ? (
              <SingleAbout auction={auction} page={page} />
            ) : (
              <>
                {symbolType === "Catalog" ? (
                  <CatalogAbout auction={auction} page={page} />
                ) : (
                  <>
                    {symbolType === "Part of an album" ? (
                      <>
                        {auction.tracks.length > 1 ? (
                          <SymbolAbout auction={auction} page={page} />
                        ) : (
                          <AlbumPartAbout auction={auction} page={page} />
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </>
                )}
              </>
            )}
          </>
        )}
      </CMAuctionAbout>
    );
  };
  
  const SingleAbout = ({ auction, page, ...props }) => {
    const [expanded, setExpanded] = useState(true);
    const [trackOptions, setTrackOptions] = useState([]);
    const ellipsisRef = useRef(null);
    const location = useLocation();

    useEffect(() => {
      if (auction?.tracks) {
        const trackIds = new Set();
        const options = auction.tracks
          .map((track, index) => {
            const newsData = !!track.in_the_news;
            if (!trackIds.has(track.id) && newsData) {
              trackIds.add(track.id);
              return {
                value: String(index),
                label: track.title,
                new: newsData,
              };
            }
            return null;
          })
          .filter(Boolean);
        setTrackOptions(options);
      }
    }, [auction]);

    useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has("expand") && ellipsisRef.current) {
      ellipsisRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    }, [location.search]);
  
    const handleChange = () => {
      setExpanded((prev) => !prev);
    };
  
    return (
      <Accordion expanded={expanded} hidden={auction?.description || trackOptions.length  ? false : true}>
        <MainBox onClick={handleChange} style={{ paddingBottom: 0 }}>
          <StyledAccordionSummary expandIcon={<ExpandMoreIcon />}>
            <h3>{page ? "About" : "About the Auction"}</h3>
          </StyledAccordionSummary>
        </MainBox>
        <StyledAccordionDetails>
          {auction.description && (
            <MainBox style={{ paddingTop: 0 }}>
              <div ref={ellipsisRef}>
                <Ellipsis
                  
                  text={auction.description}
                  limit={500}
                  tail={"Read More..."}
                  closedTail={"Read Less..."}
                />
              </div>
            </MainBox>
          )}
          <TrackPerformance auction={auction} />
          <MainBox>
            <ArtistMomentum auction={auction} />
            <AuctionMentions
              auction={auction}
              mentions={auction.mentions}
              trackOptions={trackOptions}
            />
          </MainBox>
        </StyledAccordionDetails>
      </Accordion>
    );
  };
  
  const SymbolAbout = ({ auction, page, ...props }) => {
    const [expanded, setExpanded] = useState(true);
    const isMobile = useMediaQuery("(max-width:992px)");
  
    const handleChange = () => {
      setExpanded((old) => !old);
    };
  
    const hiddenColumnsMobile = {
      index: false,
      imgSrc: false,
      isrc: false,
      album: false,
      releaseDate: false,
      id: false,
    };
  
    return (
      <Accordion expanded={expanded}>
        <MainBox onClick={handleChange} style={{ paddingBottom: 0 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <h3>{page ? "About" : "About the Symbol"}</h3>
          </AccordionSummary>
        </MainBox>
        <AccordionDetails>
          <MainBox style={{ paddingTop: 0 }}>
            <CMTrackList>
              <TrackList
                tracks={auction.tracks}
                hiddenColumns={isMobile ? hiddenColumnsMobile : {}}
              />
            </CMTrackList>
          </MainBox>
          <MainBox style={{ paddingTop: 0 }}>
            <h4>About the Track(s)</h4>
            <div>
              <Ellipsis
                text={auction.description || ""}
                limit={150}
                tail={"Read More..."}
                closedTail={"Read Less..."}
              />
            </div>
          </MainBox>
          {auction && auction.artist ? (
            <MainBox style={{ paddingTop: 0 }}>
              <h4>Artist bio, Top songwriters & Team</h4>
              <div>
                <Ellipsis
                  text={auction.artist.biography || ""}
                  limit={150}
                  tail={"Read More..."}
                  closedTail={"Read Less..."}
                />
              </div>
            </MainBox>
          ) : (
            ""
          )}
        </AccordionDetails>
      </Accordion>
    );
  };
  
  const CatalogAbout = ({ auction, page, ...props }) => {
    const [expanded, setExpanded] = useState(true);
    const isMobile = useMediaQuery("(max-width:992px)");
  
    const handleChange = () => {
      setExpanded((old) => !old);
    };
  
    const hiddenColumnsMobile = {
      index: false,
      imgSrc: false,
      album: false,
      isrc: false,
      releaseDate: false,
      id: false,
    };
  
    return (
      <Accordion expanded={expanded}>
        <MainBox onClick={handleChange} style={{ paddingBottom: 0 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <h3>{page ? "About" : "About the Symbol"}</h3>
          </AccordionSummary>
        </MainBox>
        <AccordionDetails>
          <MainBox style={{ paddingTop: 0 }}>
            <CMTrackList>
              <TrackList
                tracks={auction.tracks}
                hiddenColumns={isMobile ? hiddenColumnsMobile : {}}
              />
            </CMTrackList>
          </MainBox>
          <MainBox style={{ paddingTop: 0 }}>
            <h4>Catalog Info</h4>
            <div>
              <Ellipsis
                text={auction.description || ""}
                limit={150}
                tail={"Read More..."}
                closedTail={"Read Less..."}
              />
            </div>
          </MainBox>
        </AccordionDetails>
      </Accordion>
    );
  };
  
  const AlbumPartAbout = ({ auction, page, ...props }) => {
    const [expanded, setExpanded] = useState(true);
    const isMobile = useMediaQuery("(max-width:992px)");
  
    const handleChange = () => {
      setExpanded((old) => !old);
    };
  
    const hiddenColumnsMobile = {
      index: false,
      imgSrc: false,
      album: false,
      isrc: false,
      releaseDate: false,
      id: false,
    };
  
    return (
      <Accordion expanded={expanded}>
        <MainBox onClick={handleChange} style={{ paddingBottom: 0 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <h3>{page ? "About" : "About the Symbol"}</h3>
          </AccordionSummary>
        </MainBox>
        <AccordionDetails>
          <MainBox style={{ paddingTop: 0 }}>
            <CMTrackList>
              <TrackList
                tracks={auction.tracks}
                hiddenColumns={isMobile ? hiddenColumnsMobile : {}}
              />
            </CMTrackList>
          </MainBox>
          {auction.description ? (
            <MainBox style={{ paddingTop: 0 }}>
              {/*<h4>Single Info</h4>*/}
              <div>
                <Ellipsis
                  text={auction.description || ""}
                  limit={150}
                  tail={"Read More..."}
                  closedTail={"Read Less..."}
                />
              </div>
            </MainBox>
          ) : (
            ""
          )}
          <MainBox>
            {auction && auction.artist ? (
              <CMArtistBio>
                <h4>Artist bio, Top songwirtters & Team</h4>
                <Ellipsis
                  text={auction.artist.biography || ""}
                  limit={150}
                  tail={"Read More..."}
                  closedTail={"Read Less..."}
                />
              </CMArtistBio>
            ) : (
              ""
            )}
            {/* <AuctionMentions mentions={auction.mentions}/> */}
          </MainBox>
        </AccordionDetails>
      </Accordion>
    );
  };
  
  const AlbumAbout = ({ auction, page, ...props }) => {
    const [expanded, setExpanded] = useState(true);
    const isMobile = useMediaQuery("(max-width:992px)");
  
    const handleChange = () => {
      setExpanded((old) => !old);
    };
  
    const hiddenColumnsMobile = {
      index: false,
      imgSrc: false,
      album: false,
      isrc: false,
      releaseDate: false,
      id: false,
    };
  
    return (
      <Accordion expanded={expanded}>
        <MainBox onClick={handleChange} style={{ paddingBottom: 0 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <h3>{page ? "About" : "About the Symbol"}</h3>
          </AccordionSummary>
        </MainBox>
        <AccordionDetails>
          <MainBox style={{ paddingTop: 0 }}>
            <CMTrackList>
              <TrackList
                tracks={auction.tracks}
                hiddenColumns={isMobile ? hiddenColumnsMobile : {}}
              />
            </CMTrackList>
          </MainBox>
          <MainBox style={{ paddingTop: 0 }}>
            {/*<h4>Album info</h4>*/}
            <div>
              <Ellipsis
                text={auction.description || ""}
                limit={150}
                tail={"Read More..."}
                closedTail={"Read Less..."}
              />
            </div>
          </MainBox>
          {auction && auction.artist ? (
            <MainBox style={{ paddingTop: 0 }}>
              <h4>Artist bio, Top songwriters & Team</h4>
              <div>
                <Ellipsis
                  text={auction.artist.biography || ""}
                  limit={150}
                  tail={"Read More..."}
                  closedTail={"Read Less..."}
                />
              </div>
            </MainBox>
          ) : (
            ""
          )}
        </AccordionDetails>
      </Accordion>
    );
  };
  
  export default AuctionAbout;
  